import React from "react";
import { Card } from "react-bootstrap";
import { FaEnvelope, FaPhone, FaLock } from "react-icons/fa";

const CoachCard = ({ coach, onCardClick, isDisabled }) => {
  return (
    <>
      <style>{`
                .modern-coach-card {
                    border-radius: 16px !important;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
                    background: #fff !important;
                    transition: box-shadow 0.2s, transform 0.2s;
                    padding: 24px 20px 20px 20px !important;
                    margin-bottom: 24px;
                    border: none !important;
                    cursor: pointer;
                }
                .modern-coach-card:hover {
                    box-shadow: 0 4px 24px #1976d233 !important;
                    transform: translateY(-2px) scale(1.01);
                }
                .modern-coach-card.disabled-coach {
                    opacity: 0.6;
                    cursor: not-allowed;
                    box-shadow: none !important;
                }
                .modern-coach-title {
                    font-size: 1.3rem;
                    font-weight: 700;
                    color: #1976d2;
                    margin-bottom: 12px;
                    display: flex;
                    direction: rtl;
                    align-items: center;
                    gap: 8px;
                }
                .modern-coach-info {
                    font-size: 1.05rem;
                    color: #333;
                    margin-bottom: 6px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                .modern-coach-icon {
                    color: #1976d2;
                    font-size: 1.1em;
                }
            `}</style>
      <Card
        className={`modern-coach-card h-100${
          isDisabled ? " disabled-coach" : ""
        }`}
        onClick={() => !isDisabled && onCardClick(coach)}
      >
        <Card.Body>
          <div className="modern-coach-title">
            {coach.userData.userName}
            {isDisabled && <FaLock className="text-muted ms-2" />}
          </div>
          <div className="modern-coach-info" dir="rtl">
            <FaEnvelope className="modern-coach-icon" />
            <span>{coach.userData.userEmailAddress}</span>
          </div>
          <div className="modern-coach-info" dir="rtl">
            <FaPhone className="modern-coach-icon" />
            <span>{coach.userData.userPhoneNumber}</span>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default CoachCard;
